export default {
      id: "ic-misc-pdf-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-pdf-usage",
      toString: function () {
        return this.url;
      }
    }